"use strict";

exports.__esModule = true;
exports.UpdateDeviceScreenPlantTwin = UpdateDeviceScreenPlantTwin;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _DeviceCollection = require("../DeviceCollection");
var _DeviceDataItemsContext = require("../DeviceDataItemsContext");
var _DeviceEditorPlantTwin = require("../DeviceEditorPlantTwin");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Screen which allows users to update existing device.
 */
function UpdateDeviceScreenPlantTwin(props) {
  var deviceCollection = _react["default"].useContext(_DeviceCollection.DeviceCollectionContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var id = props.match.params.id;
  var device = deviceCollection.optimisticRead(id);
  function handleSubmit(device) {
    deviceCollection.update(device);
  }
  var body;
  if (!device) {
    body = /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: new Error(translate("UpdateDeviceScreenPlantTwin.error.noSuchDevice", "Unknown device {id}", {
        id: id
      }))
    });
  } else {
    body = /*#__PURE__*/_react["default"].createElement(_DeviceDataItemsContext.DeviceDataItemsLoader, {
      deviceUUID: device.uuid
    }, function (_ref) {
      var loaded = _ref.loaded,
        fetching = _ref.fetching,
        error = _ref.error,
        data = _ref.data;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fetching && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null), error && /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error,
        title: "Error loading data items"
      }), loaded && data && /*#__PURE__*/_react["default"].createElement(_DeviceDataItemsContext.DeviceDataItemsContext.Provider, {
        value: data
      }, /*#__PURE__*/_react["default"].createElement(_DeviceEditorPlantTwin.DeviceEditorPlantTwin, {
        device: device,
        onSubmit: handleSubmit,
        onCancelScreenName: "DeviceListPlantTwin"
      })));
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("UpdateDeviceScreen.title", "Edit Device: {id}", {
      id: id
    })
  }, body);
}